import { CourseSingleUpdate, CourseFindById, CourseTerminalListByCourse } from './Request';

const mapCourse = (course, courseTerminals) => ({
  id: course.id,
  name: course.name,
  category: course?.CourseCategory?.id ?? '',
  description: course?.description ?? '',
  priority: course?.Priority?.id ?? '',
  thumbnail: course?.thumbnail ?? '',
  terminals: courseTerminals,
});

export const updateCourse = async ({ id, isDraft }) => {
  const response = await CourseSingleUpdate({ id, isDraft });
  return response !== 0;
};

export const courseIsValid = async ({ id = '' }) => {
  const courseObject = await CourseFindById({
    id,
  });

  // Un curso que no se pudo cargar no se puede validar, y por lo tanto tampoco
  // publicar. Sin esta guarda el mapeo revienta y la pestaña queda en blanco.
  if (!courseObject) return { isValid: false };

  const courseTerminals = await CourseTerminalListByCourse({
    courseId: id,
  });

  const mappedObject = mapCourse(courseObject, courseTerminals);

  // La vigencia ya no se valida aquí: dejó de ser `expirationTime` y ahora vive
  // en `expirationRule`/`dueAmount`, que son opcionales (un curso sin ciclo es
  // válido). El formulario de Información Básica valida la regla al guardar.
  let isValid = false;

  if (
    mappedObject.name &&
    mappedObject.category !== '' &&
    mappedObject.priority !== '' &&
    mappedObject.terminals.length > 0
  ) {
    isValid = true;
  }
  return { isValid };
};

export default { updateCourse, courseIsValid };
